import { render } from "./trendingGlitz.vue?vue&type=template&id=3e3e60fd&scoped=true"
import script from "./trendingGlitz.vue?vue&type=script&lang=js"
export * from "./trendingGlitz.vue?vue&type=script&lang=js"

import "./trendingGlitz.vue?vue&type=style&index=0&id=3e3e60fd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e3e60fd"]])

export default __exports__